<template>

  <div class="small-box" :class="bgColor">
    <div class="inner">
      <h3>{{title}}</h3>

      <p>{{description}}</p>
    </div>
    <div class="icon">
      
      <font-awesome-icon :icon="icon" />
    </div>
    
    <a href="#" class="small-box-footer" @click="moreEvent">{{moreText}} </a>
  </div>
</template>

<script>
export default {
  name: 'SmallBox',
  props: ['color', 'icon', 'title', 'description', 'moreText'],
  computed: {
    bgColor () {
      return `bg-${this.color}`
    }
  },
  methods: {
    moreEvent () {
      this.$emit('more-click')
    }
  }
}
</script>
<style scoped>
.small-box h3{
  font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// VASmallBox.vue?9b4d82fa